import React from "react";
import { cn } from "../../utils/cn";
import { ChevronDown } from "lucide-react";

const Select = React.forwardRef(({
  className,
  label,
  error,
  required = false,
  id,
  options = [],
  placeholder = "Seleccionar...",
  ...props
}, ref) => {
  const selectId = id || `select-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="space-y-2">
      {label && (
        <label
          htmlFor={selectId}
          className={cn(
            "text-sm font-medium leading-none",
            error ? "text-destructive" : "text-foreground"
          )}
        >
          {label}
          {required && <span className="text-destructive ml-1">*</span>}
        </label>
      )}

      <div className="relative">
        <select
          className={cn(
            "flex h-10 w-full appearance-none rounded-md border border-input bg-background px-3 py-2 pr-10 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-destructive focus-visible:ring-destructive",
            className
          )}
          ref={ref}
          id={selectId}
          {...props}
        >
          {/* Skipped when the caller supplies its own ""-valued option (e.g. an
              "All" filter choice) — otherwise the disabled placeholder wins and
              the real option can never be selected. */}
          {!options.some((option) => option.value === "") && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
      </div>

      {error && (
        <p className="text-sm text-destructive">
          {error}
        </p>
      )}
    </div>
  );
});

Select.displayName = "Select";

export { Select };
export default Select;
